// 사업자번호 상태조회 api key
export const businessApiKey = "DkQeIMqMRGtTB8309iLPE0D%2FdhV9o%2BWxYr%2BM6lwg2j0KCwWx1ivbyIOCTZxYB5t1UujbAA8tFJ1YcQP20XYcoQ%3D%3D"

